export const version = 'kunde-v1.20.0-SNAPSHOT-246b012940bbed940fb6ed906d47f177bd0d6cd8';